import FormModal from "@/components/modals/FormModal";
import React, { FC } from "react";

interface VideoModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    videoUrl: string;
}

const VideoModal: FC<VideoModalProps> = ({ isOpen, onClose, title, videoUrl }) => {
    return (
        <FormModal
            overflow="overflow-hidden"
            modalTitle={title}
            isOpen={isOpen}
            width="lg:w-3/6 md:w-5/6 w-full"
            height="overflow-y-auto"
            onClose={onClose}
        >
            <div className="w-full aspect-video rounded-xl overflow-hidden bg-black">
                {isOpen && (
                    <iframe
                        key={videoUrl}
                        className="w-full h-full"
                        src={`${videoUrl}?autoplay=1`}
                        title={title}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                )}
            </div>
        </FormModal>
    );
};

export default VideoModal;
